(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/constants.js');

svs.challenge.constants.PRODUCT_ID = 45;
svs.challenge.constants.PRODUCT_NAME = 'challenge';
svs.challenge.constants.MAX_COUPON_PRICE = 10000;

svs.challenge.constants.eventTypes = {
  12: 31,
  '1X2': 1,
  BADA_LAGEN_GOR_MINST: 28,
  H2H: 12,
  OVER_UNDER: 4,
  TOTALT_ANTAL_MAL: 16
};

svs.challenge.constants.MAX_MATCHES_IN_STARTPAGE = 4;

svs.challenge.constants.XPERTEN = {
  10: [
    { full: 0, half: 1, size: 2 },
    { full: 1, half: 0, size: 3 },
    { full: 0, half: 2, size: 4 },
    { full: 1, half: 1, size: 6 },
    { full: 0, half: 3, size: 8 },
    { full: 1, half: 2, size: 12 },
    { full: 0, half: 4, size: 16 },
    { full: 2, half: 1, size: 18 }
  ],
  5: [
    { full: 0, half: 2, size: 4 },
    { full: 1, half: 1, size: 6 },
    { full: 0, half: 3, size: 8 },
    { full: 1, half: 2, size: 12 },
    { full: 0, half: 4, size: 16 },
    { full: 1, half: 3, size: 24 },
    { full: 0, half: 5, size: 32 },
    { full: 2, half: 2, size: 36 }
  ]
};

svs.challenge.constants.LOCAL_STORAGE_VERSION = 11;
svs.challenge.constants.LOCAL_STORAGE_NAME = 'coupons_v' + svs.challenge.constants.LOCAL_STORAGE_VERSION;
svs.challenge.constants.LOCAL_STORAGE_SETTINGS_NAME = 'settings';
svs.challenge.constants.LOCAL_STORAGE_DOMAIN = 'svs.challenge';


 })(window);